<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <canvas :id="id" height="300"></canvas>
        <div v-if="!mediaMode"
        v-bind:class="{'pt-5': $vuetify.breakpoint.smAndDown}"
        class="logo"><v-img :src="require(`@/assets/img/${ $vuetify.theme.dark ? 'driblab_white.png': 'driblab_color.png' }`)" :max-width="$vuetify.breakpoint.smAndDown ? '75px' : '125px'"></v-img></div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {getDataUrl} from '../../utils/functions';
import ResizeObserver from 'resize-observer-polyfill';

export default {
  data() {
    return {
      lineChart: null,
      observer:null
    };
  },
  props:{
    id:{
      type: String,
      required: true
    },
    datasets:{
      type: Array,
      default: () => null,
    },
    xAxisLabels:{
      type: Array,
      default: () => [],
      required: true
    },
    options: {
      type: Object,
      default: () => null,
    },
    homeFillColor:{
      type: String,
      default: "rgba(109, 125, 229, 0.5)"
    },
    homeBorderColor:{
      type: String,
      default: "rgba(7, 58, 247, 1)"
    },
    awayFillColor:{
      type: String,
      default: "rgba(125, 125, 125, 0.5)"
    },
    awayBorderColor:{
      type: String,
      default: "rgba(0, 0, 0, 1)"
    },
    mediaMode:{
      type:Boolean,
      default:false
    }
  },
  mounted() {

    this.observer = new ResizeObserver(this.onResize).observe(document.getElementById(this.id));
    this.generateChart();
    this.updateChart();
  },
  watch: {
    id(newId, oldId){
      this.updateChart();
    },
    datasets(newDataSet, oldDataSet){
      this.updateChart();
    },
    xAxisLabels(newLabels,oldLabels){
      this.updateChart();
    }
  },
  methods: {
    generateChart() {
      const ctx = document.getElementById(this.id).getContext("2d");

      //Url crest img
      const crestUrl = 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/';
      const homeCrestImage = new Image();
      homeCrestImage.crossOrigin = "anonymous";
      homeCrestImage.src = crestUrl + this.datasets[0].homeTeamId + '.png';

      const awayCrestImage = new Image();
      awayCrestImage.crossOrigin = "anonymous";
      awayCrestImage.src = crestUrl + this.datasets[0].awayTeamId + '.png';

      var homeGoal = new Image();
      homeGoal.src = require('@/assets/icons/homeGoal.png');

      var homePenaltyGoal = new Image();
      homePenaltyGoal.src = require('@/assets/icons/homePenaltyGoal.png');

      var missedPenalty = new Image();
      missedPenalty.src = require('@/assets/icons/missedPenalty.png');

      var homeOwnGoal = new Image();
      homeOwnGoal.src = require('@/assets/icons/homeOwnGoal.png');

      var awayGoal = new Image();
      awayGoal.src = require('@/assets/icons/awayGoal.png');

      var awayPenaltyGoal = new Image();
      awayPenaltyGoal.src = require('@/assets/icons/awayPenaltyGoal.png');

      var awayOwnGoal = new Image();
      awayOwnGoal.src = require('@/assets/icons/awayOwnGoal.png');

      var redCard = new Image();
      redCard.src = require('@/assets/icons/redCard.png');

      var homeFormationChange = new Image();
      homeFormationChange.src = require('@/assets/icons/homeFormationChange.png');

      var awayFormationChange = new Image();
      awayFormationChange.src = require('@/assets/icons/awayFormationChange.png');

      this.lineChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: this.xAxisLabels,
            datasets: this.datasets,
        },
        options: this.options,
        plugins: [{
          afterDraw: function(chart) {
            const {top, left, bottom} = chart.chartArea;
            const x = left;
            const y = top;
            const y2 = bottom - 50;
            //Apply opacity to print crests
            ctx.globalAlpha = 0.4;

            if (homeCrestImage.complete) {
              const dataUrl = getDataUrl(homeCrestImage);
              homeCrestImage.src = dataUrl;
              //Draw home crest on background
              ctx.drawImage(homeCrestImage, x, y, 50, 50);
            }

            if (awayCrestImage.complete) {
              const dataUrl = getDataUrl(awayCrestImage);
              awayCrestImage.src = dataUrl;
              //Draw away crest on background
              ctx.drawImage(awayCrestImage, x, y2, 50, 50);
            }
            //Restore normal opacity to print chart
            ctx.globalAlpha = 1;

            //For non per phases chart, firstMinuteOfThePhase should be 1
            let firstMinuteOfThePhase = chart.config.data.datasets[0].firstMinuteOfThePhase;
            let firstHalfExtraTime = chart.config.data.datasets[0].firstHalfExtraTime;
            let homeGoals = chart.config.data.datasets[0].homeGoals;
            let homeMissedPenalties = chart.config.data.datasets[0].homeMissedPenalties;
            let homeRedCardsMinute = chart.config.data.datasets[0].homeRedCardsMinute;
            let awayGoals = chart.config.data.datasets[0].awayGoals;
            let awayMissedPenalties = chart.config.data.datasets[0].awayMissedPenalties;
            let awayRedCardsMinute = chart.config.data.datasets[0].awayRedCardsMinute;
            let homeFormationChangeMinute = chart.config.data.datasets[0].homeFormationChangeMinute;
            let awayFormationChangeMinute = chart.config.data.datasets[0].awayFormationChangeMinute;

            //Print Home Team Goals
            if(homeGoals){
              homeGoals.forEach(goal => {

                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = goal.periodId > 1 ? firstHalfExtraTime : 0;
                //Need substract firstMinuteOfThePhase and add firstHalfExtraTime
                //because goal minute and index should be the same to can print de soccer ball as goal
                let index = goal.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;
                let imgToDraw;
                //If homeGoalQualifierId is null (means is normal goal, not penalty (9), not own goal (28))
                if(!goal.homeGoalQualifierId){
                  imgToDraw = homeGoal;
                }else if(goal.homeGoalQualifierId === 9){
                  //9 -> Is Penalty Goal
                  imgToDraw = homePenaltyGoal;
                }else if(goal.homeGoalQualifierId === 28){
                  //28 -> Is Own Goal
                  imgToDraw = homeOwnGoal;
                }

                ctx.drawImage(imgToDraw, xFC - 7, y, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, 20);
                ctx.strokeStyle = '#3366FF';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, yFC);
                ctx.stroke();

              });
            }

            if(homeMissedPenalties){
              //Print Home Team Missed Penalties
              homeMissedPenalties.forEach(hmp => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = hmp.periodId > 1 ? firstHalfExtraTime : 0;
                //Need substract firstMinuteOfThePhase and add firstHalfExtraTime
                //because goal minute and index should be the same to can print de soccer ball as missed penalty
                let index = hmp.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;

                ctx.drawImage(missedPenalty, xFC - 7, y, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, 20);
                ctx.strokeStyle = '#FF0000';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, yFC);
                ctx.stroke();

              });
            }

            if(homeRedCardsMinute){
              //Print Home Team Red Cards
              homeRedCardsMinute.forEach(rc => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = rc.periodId > 1 ? firstHalfExtraTime : 0;
                //Need substract firstMinuteOfThePhase and add firstHalfExtraTime
                //because red card minute and index should be the same to can print the red card
                let index = rc.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;
                ctx.drawImage(redCard, xFC - 4.5, y, 9, 12);

                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, 20);
                ctx.strokeStyle = '#3366FF';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, yFC);
                ctx.stroke();
              });
            }


            if(homeFormationChangeMinute){
              //Print Home Team Formation Change
              homeFormationChangeMinute.forEach((htfc, i) => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = htfc.periodId > 1 ? firstHalfExtraTime : 0;
                //Need substract firstMinuteOfThePhase and add firstHalfExtraTime
                //because home formation change minute and index should be the same to can print the img
                let index = htfc.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;
                ctx.drawImage(homeFormationChange, xFC - 7, y, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, 20);
                ctx.strokeStyle = '#3366FF';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, yFC);
                ctx.stroke();
              });
            }


            if(awayGoals){
              //Print Away Team Goals
              awayGoals.forEach(goal => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = goal.periodId > 1 ? firstHalfExtraTime : 0;
                //Need - firstMinuteOfThePhase because goal minute and index should be the same to can print the soccer ball as goal
                let index = goal.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;
                let imgToDraw;
                //If homeGoalQualifierId is null (means is normal goal, not penalty (9), not own goal (28))
                if(!goal.homeGoalQualifierId){
                  imgToDraw = awayGoal;
                }else if(goal.homeGoalQualifierId === 9){
                  //9 -> Is Penalty Goal
                  imgToDraw = awayPenaltyGoal;
                }else if(goal.homeGoalQualifierId === 28){
                  //28 -> Is Own Goal
                  imgToDraw = awayOwnGoal;
                }

                ctx.drawImage(imgToDraw, xFC - 7, bottom - 14, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, yFC);
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, bottom);
                ctx.stroke();

              });

            }


            if(awayMissedPenalties){
              //Print Away Team Missed Penalties
              awayMissedPenalties.forEach(amp => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = amp.periodId > 1 ? firstHalfExtraTime : 0;
                //Need - firstMinuteOfThePhase because goal minute and index should be the same to can print the soccer ball as goal
                let index = amp.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;

                ctx.drawImage(missedPenalty, xFC - 7, bottom - 14, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, yFC);
                ctx.strokeStyle = '#FF0000';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, bottom);
                ctx.stroke();

              });
            }

            if(awayRedCardsMinute){
              //Print Away Team Red Cards
              awayRedCardsMinute.forEach(rc => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = rc.periodId > 1 ? firstHalfExtraTime : 0;
                //Need - firstMinuteOfThePhase because red card minute and index should be the same to can print the red card
                let index = rc.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;

                ctx.drawImage(redCard, xFC - 7, bottom - 14, 9, 12);

                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, yFC);
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, bottom);
                ctx.stroke();
              });
            }


            if(awayFormationChangeMinute){
              //Print Away Team Formation Change
              awayFormationChangeMinute.forEach(atfc => {
                //Just need add firstHalfExtraTime minutes on second half goals
                let offsetFirstHalfExtraTime = atfc.periodId > 1 ? firstHalfExtraTime : 0;
                //Need substract firstMinuteOfThePhase and add firstHalfExtraTime
                //because home formation change minute and index should be the same to can print the img
                let index = atfc.minute - firstMinuteOfThePhase + offsetFirstHalfExtraTime;
                let xFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.x;
                let yFC = Object.values(chart.config.data.datasets[0]._meta)[0].data[index]._model.y;

                ctx.drawImage(awayFormationChange, xFC - 7, bottom - 14, 14, 14);
                // Draw vertical line from img to chart point
                ctx.beginPath();
                ctx.moveTo(xFC, yFC);
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 0.3;
                ctx.lineTo(xFC, bottom);
                ctx.stroke();
              });
            }

          }
        }]
      });

    },
    updateChart() {
      const ctx = document.getElementById(this.id).getContext("2d");
      //Get max value away team (min because values are negative)
      var maxValueAwayTeam = Math.min.apply(null, this.lineChart.data.datasets[0].data);
      //Get max value home team (positive values)
      var maxValueHomeTeam = Math.max.apply(null, this.lineChart.data.datasets[0].data);

      var linearGradient = ctx.createLinearGradient(maxValueAwayTeam, 0, maxValueHomeTeam, 0);
      //Update ticks (number of labels on X Axis)
      this.lineChart.scales['x-axis-0'].ticks = this.xAxisLabels;

      var Y = this.lineChart.scales['y-axis-0'];
      Y.bottom = Y.bottom ? Y.bottom : 0;
      let zeroPointY = Y.top + ((Y.bottom - Y.top) / (Y.ticks.length -1) * Y.zeroLineIndex);

      // Build a gradient that switches color at the 0 point
      var gradient = ctx.createLinearGradient(0, Y.top, 0, Y.bottom);
      var gradientLine = ctx.createLinearGradient(0, Y.top, 0, Y.bottom);
      var ratio = Math.min((zeroPointY - Y.top) / (Y.bottom - Y.top), 1);

      //101, 149, 212 - Blue Fill (Radar)
      gradient.addColorStop(0, this.homeFillColor);
      gradient.addColorStop(ratio, this.homeFillColor);
      //125, 125, 125 - Gray Fill (Radar)
      gradient.addColorStop(ratio, this.awayFillColor);
      gradient.addColorStop(1, this.awayFillColor);
      //7,58,247 - Blue Border (Radar)
      gradientLine.addColorStop(0, this.homeBorderColor);
      gradientLine.addColorStop(ratio, this.homeBorderColor);
      //0, 0, 0 - Black Line (Radar)
      gradientLine.addColorStop(ratio, this.awayBorderColor);
      gradientLine.addColorStop(1, this.awayBorderColor);

      //Draw fill between chart and zero line
      this.lineChart.data.datasets[0].backgroundColor = gradient;
      //Draw line. Blue for positive values and black for negatives
      this.lineChart.data.datasets[0].borderColor = gradientLine;

      //Empty labels array
      this.lineChart.data.labels = [];
      this.lineChart.data.labels.length = 0;
      //Reload labels
      this.xAxisLabels.forEach((xLabel) => {
        this.lineChart.data.labels.push(xLabel);
      });

      //Update chart
      this.lineChart.update();

      //Emit when is loaded
      this.$emit("loaded", this.id);
    },
    onResize(){
      let elto = document.getElementById(this.id);
      if(elto){
        this.$emit("sizeChange", {height:elto.clientHeight,width:elto.clientWidth});
      }
    }
  },
  destroyed() {
    delete this.observer;
  },
};
</script>
<style>
  .logo{
    position: absolute;
    top: 86%;
    right: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/views/charts/ZeroLineChart.vue